import { Image } from 'antd-mobile'
import { AddSquareOutline } from 'antd-mobile-icons'
import { isEmpty } from 'lodash-es'
import { toJS } from 'mobx'
import { observer, useLocalObservable } from 'mobx-react-lite'
import React, { useEffect } from 'react'

import jobStore from '@/store/components/entryJob'

import getQuery from '@/utils/getQuery'

import { HBlockAdd } from '../../HYBVant'

import Popup from './Popup'

import './index.less'
import useLocalRewardPunishment from './useLocalRewardPunishment'
import useRewardPunishment from './useRewardPunishment'

interface ITrainingRecord {
  onConfirm?: (data: any) => void
  isLocalObserver?: boolean
  isAuth?: boolean
  value?: any
}
const TrainingRecord: React.FC<ITrainingRecord> = ({
  onConfirm,
  isLocalObserver = true,
  isAuth = true,
  value
}) => {
  const staffId = decodeURIComponent(getQuery('staffId') || '')
  const { employeeIds } = useLocalObservable(() => jobStore)
  const staff_Id = employeeIds?.[0] || staffId
  const local = useLocalRewardPunishment({
    onConfirm,
    value
  })
  const remote = useRewardPunishment({
    onConfirm,
    value
  })
  const {
    add,
    edit,
    open,
    modalData,
    onCancel,
    runDeleteTraining,
    runSaveTraining,
    deleteTrainingLoading,
    saveTrainingLoading
  } = isLocalObserver ? local : remote
  console.log('value', toJS(value))
  return (
    <div className='health_certificate'>
      {!isEmpty(value) && (
        <div className='health_certificate-content-wrapper'>
          {value?.map((x: any, index: number) => (
            <div
              key={x}
              className='health_certificate-content'
              onClick={() => isAuth && edit(index)}
            >
              <div className='health_certificate-content-col-1'>
                <div className='health_certificate-content-1'>
                  课程名称: {x?.training_course_name || '-'}
                </div>
                <div className='health_certificate-content-3'>
                  培训日期：{x?.training_date || '-'}
                </div>
              </div>
              <div className='health_certificate-content-col-2'>
                {isAuth && (
                  <Image
                    className='hyb-com-concat-content-col-2-img'
                    src='https://s.huiyunban.cn/1747191709529280512.png'
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      {isAuth && <HBlockAdd onClick={add} text='添加培训记录' />}
      {open && (
        <Popup
          visible={open}
          onCancel={onCancel}
          modalData={{
            ...modalData,
            staff_Id,
            runDeleteTraining,
            runSaveTraining,
            deleteTrainingLoading,
            saveTrainingLoading
          }}
        />
      )}
    </div>
  )
}

export default observer(TrainingRecord)
